export const pathHome = '/activatedEvaluations';
export const pathLogin = '/login';
export const pathLogout = '/logout';
export const pathLoggedOut = '/logged-out';
export const pathPrivacyPolicy = '/api/v1/privacy-policy';

// String-only path routes are defined in a separate file as otherwise some sort of
// circular import mess was created: routes imports PartyService which imports azureAd
// which would've imported routes (pathLogout). The app seemed to work fine despite
// this, but in the console one could see some errors.


// WEBPACK FOOTER //
// ./modules/issFrontend/paths.js